'use strict';

var _extends = Object.assign || function (target) {
  for (var source, i = 1; i < arguments.length; i++) {
    for (var key in source = arguments[i], source) {
      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
  }

  return target;
},
    _createClass = function () {
  function defineProperties(target, props) {
    for (var descriptor, i = 0; i < props.length; i++) {
      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
  };
}(),
    _templateObject = _taggedTemplateLiteral(['\n  box-sizing: border-box;\n  & *,\n  & *::before,\n  & *::after {\n    box-sizing: inherit;\n  }\n\n  button {\n    cursor: pointer;\n  }\n  button[disabled] {\n    cursor: default;\n  }\n'], ['\n  box-sizing: border-box;\n  & *,\n  & *::before,\n  & *::after {\n    box-sizing: inherit;\n  }\n\n  button {\n    cursor: pointer;\n  }\n  button[disabled] {\n    cursor: default;\n  }\n']),
    _react = require('react'),
    _react2 = _interopRequireDefault(_react),
    _reactDom = require('react-dom'),
    _reactDom2 = _interopRequireDefault(_reactDom),
    _propTypes = require('prop-types'),
    _propTypes2 = _interopRequireDefault(_propTypes),
    _styledComponents = require('styled-components'),
    _styledComponents2 = _interopRequireDefault(_styledComponents),
    _TableHeader = require('./TableHeader'),
    _TableHeader2 = _interopRequireDefault(_TableHeader),
    _TableBody = require('./TableBody'),
    _TableBody2 = _interopRequireDefault(_TableBody),
    _TableRow = require('./TableRow'),
    _TableRow2 = _interopRequireDefault(_TableRow),
    _TableHeaderCell = require('./TableHeaderCell'),
    _TableHeaderCell2 = _interopRequireDefault(_TableHeaderCell),
    _TableDataCell = require('./TableDataCell'),
    _TableDataCell2 = _interopRequireDefault(_TableDataCell),
    _Card = require('../Card'),
    _Card2 = _interopRequireDefault(_Card),
    _styles = require('../styles'),
    _withCommonProps = require('../withCommonProps'),
    _withCommonProps2 = _interopRequireDefault(_withCommonProps),
    _themes = require('../themes'),
    _propTypes3 = require('../propTypes'),
    _componentTheme = require('./componentTheme'),
    _componentTheme2 = _interopRequireDefault(_componentTheme);

Object.defineProperty(exports, '__esModule', {
  value: !0
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }

  return Array.from(arr);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
}

function _possibleConstructorReturn(self, call) {
  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
  return call && ('object' == typeof call || 'function' == typeof call) ? call : self;
}

function _inherits(subClass, superClass) {
  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Styled = {
  Card: {},
  div: {},
  table: {}
},
    normalizeStyles = (0, _styles.css)(_templateObject);
Styled.Card.root = (0, _styledComponents2.default)(_Card2.default).withConfig({
  displayName: 'Table__root'
})(['', ';', ';width:', ';max-width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch;font-family:', ';font-size:', ';font-weight:', ';line-height:1.5;@media print{max-width:none;overflow:visible;border:none;}'], _styles.resetInheritedStyles, normalizeStyles, function (props) {
  return props.sc.fullWidth ? '100%' : 'auto';
}, (0, _themes.getStyle)('Table_fontFamily'), function (props) {
  return props.theme.vstui.rem((0, _themes.getStyle)('Table_fontSize')(props));
}, (0, _themes.getStyle)('Table_fontWeight')), Styled.div.tableWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'Table__tableWrapper'
})(['position:relative;display:table;width:100%;']), Styled.div.headerTableWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'Table__headerTableWrapper'
})(['position:absolute;top:0;right:0;bottom:0;left:0;z-index:2;margin-right:', 'px;pointer-events:none;'], function (props) {
  return props.scrollable ? props.scrollbarWidth : 0;
}), Styled.table.header = _styledComponents2.default.table.withConfig({
  displayName: 'Table__header'
})(['position:absolute;top:0;left:0;width:100%;border-collapse:separate;border-spacing:0;thead{th{position:relative;pointer-events:auto;}position:relative;}tbody{visibility:hidden;tr{th,td{padding-top:0;padding-bottom:0;border-top:none;border-bottom:none;line-height:0.1;}& + tr th,& + tr td{line-height:0;}}}tbody tr:last-child td{border-bottom:none;}tfoot{position:relative;th,td{position:relative;}}@media print{display:none;}']), Styled.div.bodyTableWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'Table__bodyTableWrapper'
})(['position:relative;z-index:1;width:100%;max-height:', ';overflow-y:', ';-webkit-overflow-scrolling:touch;outline-offset:-10px;@media print{max-height:100%;overflow:visible;}'], function (props) {
  return props.maxHeight ? props.theme.vstui.rem(props.maxHeight) : 'none';
}, function (props) {
  return props.scrollable ? 'scroll' : 'visible';
}), Styled.table.body = _styledComponents2.default.table.withConfig({
  displayName: 'Table__body'
})(['width:100%;border-collapse:separate;border-spacing:0;tbody tr:last-child td{border-bottom:none;}@media print{page-break-inside:avoid;}']);

var Table = function (_Component) {
  function Table() {
    _classCallCheck(this, Table);

    var _this = _possibleConstructorReturn(this, (Table.__proto__ || Object.getPrototypeOf(Table)).call(this));

    return _this.handleBodyTableRef = _this.handleBodyTableRef.bind(_this), _this.handleHeaderClick = _this.handleHeaderClick.bind(_this), _this.compare = _this.compare.bind(_this), _this.state = {
      scrollable: !1,
      sortOrder: 1,
      sortedHeaderIndex: null,
      scrollbarWidth: _this.getScrollbarWidth()
    }, _this;
  }

  return _inherits(Table, _Component), _createClass(Table, [{
    key: 'getScrollbarWidth',
    value: function getScrollbarWidth() {
      var outer = document.createElement('div');
      outer.style.visibility = 'hidden', outer.style.width = '100px', document.body.appendChild(outer);
      var widthWithoutScroll = outer.offsetWidth;
      outer.style.overflow = 'scroll';
      var inner = document.createElement('div');
      inner.style.width = '100%', outer.appendChild(inner);
      var widthWithScroll = inner.offsetWidth;
      return outer.parentNode.removeChild(outer), widthWithoutScroll - widthWithScroll;
    }
  }, {
    key: 'getSortValue',
    value: function getSortValue(row) {
      var cellData = Object.values(row)[this.state.sortedHeaderIndex];
      return void 0 === cellData || null === cellData ? null : cellData.content ? cellData.sort || this.toString(cellData.content) : this.toString(cellData);
    }
  }, {
    key: 'toString',
    value: function toString(element) {
      var _this2 = this;

      if (_react2.default.isValidElement(element)) return this.toString(_react2.default.Children.toArray(element.props.children));

      if (Array.isArray(element)) {
        var _ref,
            array = element.map(function (child) {
          return 'string' == typeof child ? child.toLowerCase() : _this2.toString(child);
        });

        return (_ref = []).concat.apply(_ref, _toConsumableArray(array)).join('');
      }

      return element;
    }
  }, {
    key: 'compare',
    value: function compare(rowA, rowB) {
      var sortValueA = this.getSortValue(rowA),
          sortValueB = this.getSortValue(rowB);
      return sortValueA > sortValueB ? this.state.sortOrder : sortValueA < sortValueB ? -1 * this.state.sortOrder : 0;
    }
  }, {
    key: 'handleBodyTableRef',
    value: function handleBodyTableRef(table) {
      var maxStaticHeight = this.props.maxStaticHeight;

      if (table && maxStaticHeight) {
        var height,
            pxRegex = /px$/,
            percentRegex = /%$/;
        if (maxStaticHeight.match(pxRegex)) height = parseInt(maxStaticHeight.split(pxRegex)[0], 10);else if (maxStaticHeight.match(percentRegex)) {
          var rootNode = _reactDom2.default.findDOMNode(this),
              parentHeight = rootNode.parentNode.offsetHeight;

          height = parentHeight * (parseInt(maxStaticHeight.split(percentRegex)[0], 10) / 100);
        }
        this.setState({
          maxHeight: height + 'px',
          scrollable: !0
        });
      }
    }
  }, {
    key: 'handleHeaderClick',
    value: function handleHeaderClick(event, index) {
      -1 === this.state.sortOrder || this.state.sortedHeaderIndex !== index ? this.setState({
        sortOrder: 1,
        sortedHeaderIndex: index
      }) : this.setState({
        sortOrder: -1,
        sortedHeaderIndex: index
      });
    }
  }, {
    key: 'renderHeaderTable',
    value: function renderHeaderTable(theme) {
      return _react2.default.createElement(Styled.table.header, null, this.renderTableHeader('header', theme), this.renderTableBody(theme));
    }
  }, {
    key: 'renderBodyTable',
    value: function renderBodyTable(theme) {
      return _react2.default.createElement(Styled.table.body, {
        innerRef: this.handleBodyTableRef
      }, this.renderTableHeader('body', theme), this.renderTableBody(theme));
    }
  }, {
    key: 'renderTableHeader',
    value: function renderTableHeader(tableType, theme) {
      var _this3 = this,
          columns = this.props.columns,
          _state = this.state,
          sortedHeaderIndex = _state.sortedHeaderIndex,
          sortOrder = _state.sortOrder;

      return _react2.default.createElement(_TableHeader2.default, {
        theme: theme
      }, _react2.default.createElement(_TableRow2.default, {
        theme: theme
      }, columns.map(function (column, index) {
        return _react2.default.createElement(_TableHeaderCell2.default, {
          hidden: !0 === column.hiddenHeader,
          index: index,
          key: index,
          numeric: !0 === column.numeric,
          onClick: _this3.handleHeaderClick,
          sortIndex: sortedHeaderIndex,
          sortOrder: sortOrder,
          tableType: tableType,
          theme: theme
        }, column.header);
      })));
    }
  }, {
    key: 'renderTableBody',
    value: function renderTableBody(theme) {
      var _this4 = this,
          _props = this.props,
          rows = _props.rows,
          secondary = _props.secondary,
          _state2 = this.state,
          sortedHeaderIndex = _state2.sortedHeaderIndex,
          sortOrder = _state2.sortOrder,
          sortedRows = void 0;

      return sortedRows = null === this.state.sortedHeaderIndex ? rows : rows.sort(this.compare), _react2.default.createElement(_TableBody2.default, {
        secondary: secondary,
        sortIndex: sortedHeaderIndex,
        sortOrder: sortOrder,
        theme: theme
      }, sortedRows.map(function (row, rowIndex) {
        return _react2.default.createElement(_TableRow2.default, {
          key: rowIndex,
          theme: theme
        }, _this4.props.columns.map(function (column, columnIndex) {
          return _this4.renderTableDataCell(row, column, columnIndex, theme);
        }));
      }));
    }
  }, {
    key: 'renderTableDataCell',
    value: function renderTableDataCell(row, column, columnIndex, theme) {
      var secondary = this.props.secondary,
          hover = this.state.hover,
          cellData = row[column.rowKey],
          content = void 0;
      return content = void 0 === cellData || null === cellData ? null : cellData.content ? cellData.content : cellData, _react2.default.createElement(_TableDataCell2.default, {
        key: columnIndex,
        numeric: !0 === column.numeric,
        rowHover: hover,
        secondary: secondary,
        theme: theme
      }, content);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          className = _props2.className,
          commonProps = _props2.commonProps,
          dir = _props2.dir,
          fullWidth = _props2.fullWidth,
          inheritStyles = _props2.inheritStyles,
          raised = _props2.raised,
          themeProp = _props2.theme,
          _state3 = this.state,
          maxHeight = _state3.maxHeight,
          scrollable = _state3.scrollable,
          scrollbarWidth = _state3.scrollbarWidth,
          theme = (0, _componentTheme2.default)(themeProp);
      return _react2.default.createElement(Styled.Card.root, _extends({}, commonProps, {
        className: className,
        dir: dir,
        raised: raised,
        sc: {
          fullWidth: fullWidth,
          inheritStyles: inheritStyles
        },
        theme: theme
      }), _react2.default.createElement(Styled.div.tableWrapper, null, _react2.default.createElement(Styled.div.headerTableWrapper, {
        "aria-hidden": !0,
        scrollable: scrollable,
        scrollbarWidth: scrollbarWidth
      }, this.renderHeaderTable(theme)), _react2.default.createElement(Styled.div.bodyTableWrapper, {
        maxHeight: maxHeight,
        role: 'region',
        scrollable: scrollable,
        tabIndex: scrollable ? 0 : void 0
      }, this.renderBodyTable(theme))));
    }
  }]), Table;
}(_react.Component);

Table.propTypes = {
  className: _propTypes2.default.string,
  columns: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    header: _propTypes2.default.string.isRequired,
    hiddenHeader: _propTypes2.default.bool,
    numeric: _propTypes2.default.bool,
    rowKey: _propTypes2.default.string.isRequired
  })).isRequired,
  commonProps: _propTypes3.commonPropsShape,
  dir: _propTypes2.default.oneOf(['ltr', 'rtl', 'auto']),
  fullWidth: _propTypes2.default.bool,
  inheritStyles: _propTypes2.default.bool,
  maxStaticHeight: _propTypes2.default.string,
  raised: _propTypes2.default.bool,
  rows: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
  secondary: _propTypes2.default.bool,
  theme: _propTypes3.themeShape
}, Table.defaultProps = {
  theme: (0, _themes.createTheme)()
}, Table.displayName = 'Table';
var TableWithTheme = (0, _withCommonProps2.default)(Table);
TableWithTheme.WrappedComponent = Table, exports.default = TableWithTheme;